import { createContext, useContext, useMemo, type ReactNode } from 'react';
import { useTableSearchState } from '@/hooks/useTableSearchState';

type ScheduleSearchContextValue = {
  searchInput: string;
  setSearchInput: (value: string) => void;
  debouncedSearch: string;
  clearSearch: () => void;
};

const ScheduleSearchContext = createContext<ScheduleSearchContextValue | null>(null);

export function ScheduleSearchProvider({ children }: { children: ReactNode }) {
  const { searchInput, setSearchInput, debouncedSearch, clearSearch } = useTableSearchState();

  const value = useMemo(
    () => ({
      searchInput,
      setSearchInput,
      debouncedSearch,
      clearSearch,
    }),
    [searchInput, setSearchInput, debouncedSearch, clearSearch]
  );

  return <ScheduleSearchContext.Provider value={value}>{children}</ScheduleSearchContext.Provider>;
}

export function useScheduleSearch(): ScheduleSearchContextValue {
  const ctx = useContext(ScheduleSearchContext);
  if (!ctx) {
    throw new Error('useScheduleSearch must be used within ScheduleSearchProvider');
  }
  return ctx;
}
